import {PROJECT_DOMAIN} from '../project/PROJECT_DOMAIN';
/**
 * @group Constants
 * @summary Website download URL for direct Android APK installs.
 *
 * @example
 * ```typescript
 * import { ANDROID_WEBSITE_DOWNLOAD_URL } from '@shared/constants';
 *
 * window.open(ANDROID_WEBSITE_DOWNLOAD_URL, '_blank');
 * ```
 */
export const ANDROID_WEBSITE_DOWNLOAD_URL = `/download/android` as const;
